import ExchangeRate from './ExchangeRate.duck';

export default { ExchangeRate };
